<div class="container">
  <h1>PURCHASE SUCCESSFUL</h1>
  <app-order-details [order]="order$ | async"></app-order-details>
</div>
